import { Badge, Container, Header, Spinner, Box } from '@amzn/awsui-components-core';
import {
  BarRaiserReviewCount,
  TechDomain,
  TechDomainDisplayNames,
} from '@amzn/awscat-pattern-library-service-model';
import React, { useEffect, useState } from 'react';
import { MplServiceClientFactory } from '../../api/MplServiceClientFactory';
import '../../resources/styles/scss/components/bar-raiser/bar-raiser-leaderboard.css';
import constants from '../../common/constants';

interface BarRaiserLeaderboardProps {
  techDomain: string;
}

const mplService = MplServiceClientFactory.create();

export const BarRaiserLeaderboard = (props: BarRaiserLeaderboardProps) => {
  const { techDomain } = props;
  const [topBarRaisers, setTopBarRaisers] = useState<BarRaiserReviewCount[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    const getLeaderboard = async () => {
      setIsLoading(true);
      // @ts-expect-error TS7053 - strict migration
      const response = await mplService.getBarRaiserLeaderboard(TechDomain[techDomain]);
      const { topBarRaisers: barRaisers } = response;
      setTopBarRaisers(barRaisers);
      setIsLoading(false);
    };

    getLeaderboard();
  }, [techDomain]);

  const getLeaderboardRow = (barRaiserIdx: number, barRaiser: BarRaiserReviewCount) => {
    const place = barRaiserIdx + 1 + '.';
    const { userName, reviewCount } = barRaiser;
    return barRaiserIdx === 0 ? (
      <div
        className="bar-raiser-leaderboard-row"
        id={'bar-raiser-leaderboard-row-' + barRaiserIdx.toString()}
      >
        {place} {userName}
        <div className="leaderboard-spacer" id="first-leaderboard-spacer" />
        <Box float="right">
          <Badge color="green">{reviewCount}</Badge>
        </Box>
      </div>
    ) : (
      <div
        className="bar-raiser-leaderboard-row"
        id={'bar-raiser-leaderboard-row-' + barRaiserIdx.toString()}
      >
        {place} {userName}
        <div className="leaderboard-spacer" />
        <Box float="right">
          <Badge color="blue">{reviewCount}</Badge>
        </Box>
      </div>
    );
  };

  return (
    <Container
      header={
        <Header variant="h3" description={constants.BAR_RAISER_LEADERBOARD_DESCRIPTION}>
          {/* @ts-expect-error TS7053 - strict migration */}
          {TechDomainDisplayNames.get(TechDomain[techDomain])} bar raiser leaderboard
        </Header>
      }
      fitHeight
    >
      <br />
      {isLoading ? (
        <Spinner />
      ) : (
        topBarRaisers.map((barRaiser, barRaiserIdx) => getLeaderboardRow(barRaiserIdx, barRaiser))
      )}
    </Container>
  );
};
